class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.storageKey = "hideNotificationPopup";
    this.dismissed = this.getDismissedState();

    // if (this.hasSubscription || this.dismissed) return;
    if (this.dismissed) return;

    setTimeout(() => {
      this.popup.classList.remove("hidden");
      this.popup.classList.add("wt-popup-fade-in");
    }, this.delay * 1000);

    this.closeBtn.addEventListener("click", () => {
      this.popup.classList.add("hidden");
      this.setDismissedState();
    });
  }

  getDismissedState() {
    try {
      return localStorage.getItem(this.storageKey) === "true";
    } catch (error) {
      return document.cookie.includes(`${this.storageKey}=true`);
    }
  }

  setDismissedState() {
    try {
      localStorage.setItem(this.storageKey, "true");
    } catch (error) {
      this.setCookie(this.storageKey, "true", 7);
    }
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
}

customElements.define("notification-popup", NotificationPopup);
